import { Button, MuiThemeProvider, TextField, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import Alert from 'components/Shared/Alert';
import YoutubeEmbed from 'components/Shared/YoutubeEmbed';
import { WithStyles } from 'decorators/withStyles';
import * as React from 'react';
import { PureComponent } from 'react';

interface IProps {
  classes?: any;
  video: string;
  onChangeVideo: Function;
}

interface IState {
  video: string;
  openDialog: boolean;
}

@WithStyles(theme => ({
  addButton: {
    backgroundColor: theme.variables.colors['title'],
    color: '#FFF',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    '&:hover': {
      backgroundColor: theme.variables.colors['customizerTitle']
    }
  },
  removeButton: {
    color: '#DC3F53',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    border: '2px solid #DC3F53',
    padding: '6px 20px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#c33345',
      borderColor: '#c33345'
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))
export default class VideoPicker extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      video: '',
      openDialog: false
    };
  }

  handleChangeVideo = (event: any) => {
    this.setState({
      video: event.target.value
    });
  };

  onChangeVideo = () => {
    this.props.onChangeVideo(this.state.video);
  };

  removeVideo = () => {
    this.props.onChangeVideo('');
    this.setState({ video: '' });
  };

  handleCloseDialog = (ok: boolean) => {
    if (ok) {
      this.removeVideo();
    }

    this.setState({ openDialog: false });
  };

  handleOpenDialog = () => {
    this.setState({ openDialog: true });
  };

  render() {
    const { video, openDialog } = this.state;
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div>
          <TextField
            id="video-url"
            label="URL do Vídeo"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              disableUnderline: true
            }}
            fullWidth
            value={video}
            onChange={this.handleChangeVideo}
            margin="normal"
          />
          {this.props.video && <YoutubeEmbed url={this.props.video} disableAutoPlay />}
          {this.props.video ? (
            <div className={classes.buttons}>
              <Button variant="raised" className={classes.addButton} onClick={this.onChangeVideo}>
                Alterar
              </Button>
              <Button className={classes.removeButton} onClick={this.handleOpenDialog}>
                Remover
              </Button>
            </div>
          ) : (
            <Button variant="raised" className={classes.addButton} onClick={this.onChangeVideo}>
              Adicionar Vídeo
            </Button>
          )}
          <Typography variant="body1" className={classes.recomendations} gutterBottom>
            Copie o endereço do vídeo no youtube. <br />
            <i>Ex: https://www.youtube.com/D4342</i>
          </Typography>
        </div>

        <Alert
          opened={openDialog}
          title={'Remover vídeo'}
          message={'Deseja realmente remover este vídeo?'}
          confirmation
          onClose={this.handleCloseDialog}
        />
      </MuiThemeProvider>
    );
  }
}
